/**
 * descption
 * author: CarloHsu TGFE
 * Date: 2018/10/10
 * Time: 5:44 PM
 *
 */
import {
    request
} from '../http';
import domain from '../domain';

var unionPay = function() {
    if (domain.env === 'online') {
        this.domain = "//pay.51tiangou.com";
    } else {
        this.domain = "//pay." + domain.env + ".66buy.com.cn";
    }
};

unionPay.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    request(params);
};

/**
 * 设置支付密码
 * @param params
 */
unionPay.prototype.setPassword = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/password/set", params);
};

/**
 * 验证支付密码
 * 验密如果失败会累计失败次数，单日验密连续失败次数超过5次账号将被冻结
 * @param params
 */
unionPay.prototype.verifyPassword = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/password/verify", params);
};

/**
 * 绑卡
 * @param params
 */
unionPay.prototype.bindUnionCard = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/card/bind", params);
};

/**
 * 解绑
 * @param params
 */
unionPay.prototype.deleteUnionCard = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/card/binding/cancel", params);
};

/**
 * 已绑定的银行卡列表查询
 * @param params
 */
unionPay.prototype.queryUnionCardList = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/card/binding/query", params);
};

/**
 * 支持的银行列表查询
 * @param params
 */
unionPay.prototype.queryUnionSupportCard = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/banks/query", params);
};

/**
 * 生成付款码
 * @param params
 */
unionPay.prototype.createQrCode = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/qrCode/create", params);
};

/**
 * 付款功能管理
 * @param params
 * "type":0         //操作类型，1-关闭付款功能，0-开启付款功能
 */
unionPay.prototype.manageQrCode = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/qrCode/manage", params);
};

/**
 * 付款码支付功能开启状态查询
 * @param params
 */
unionPay.prototype.queryQrCodeStatus = function(params) {
    var that = this;
    params.type = 'get';
    return that._serviceAjaxCom("/publics/ysf/qrCode/status/query", params);
};

/**
 * 付款结果查询
 * 当客户端请求生成付款码后，轮询此接口，查询支付结果（0-未完成支付（继续轮询），1-支付成功，2-支付失败，3-需要验密）
 * 支付超时时间为60s（*建议客户端在申请付款码5s后，每隔5s轮询一次，轮询12次）
 * @param params
 */
unionPay.prototype.queryResult = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/qrCode/result/query", params);
};

/**
 * 历史支付流水查询
 * @param params
 */
unionPay.prototype.queryRecords = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/records/query", params);
};

/**
 * 使用说明
 * @param params
 */
unionPay.prototype.queryInstructions = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/instructions/query", params);
};

/**
 * 查询绑卡结果
 * @param params
 */
unionPay.prototype.queryCardBindResult = function(params) {
    var that = this;
    params.type = 'GET';
    return that._serviceAjaxCom("/publics/ysf/card/bindResult/query", params);
};

/*云闪付二期 安全接口*/
/**
 * 设置支付密码
 * @param params
 */
unionPay.prototype.setPasswordSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/password/set", params);
};

/**
 * 验证支付密码
 * 验密如果失败会累计失败次数，单日验密连续失败次数超过5次账号将被冻结
 * @param params
 */
unionPay.prototype.verifyPasswordSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/password/verify", params);
};

/**
 * 绑卡
 * @param params
 */
unionPay.prototype.bindUnionCardSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/card/bind", params);
};

/**
 * 解绑
 * @param params
 */
unionPay.prototype.deleteUnionCardSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/card/binding/cancel", params);
};

/**
 * 生成付款码
 * @param params
 */
unionPay.prototype.createQrCodeSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/qrCode/create", params);
};

/**
 * 付款功能管理
 * @param params
 * "type":0         //操作类型，1-关闭付款功能，0-开启付款功能
 */
unionPay.prototype.manageQrCodeSafe = function(params) {
    var that = this;
    params.type = 'POST';
    return that._serviceAjaxCom("/publics/ysf/safe/qrCode/manage", params);
};

/**
 * 获取服务器时间
 * url加随机数防止缓存
 * @param params
 */
unionPay.prototype.queryTimestamp = function(params) {
    var that = this;
    params.type = 'get';
    if(!params.data){
        params.data = {};
    }
    params.data.randomNum = Math.random();
    return that._serviceAjaxCom("/publics/ysf/timestamp/query", params);
};

export default new unionPay();